<template>
  <div class="w-full" :class="heightAuto ? '' : 'h-16'">
    <VField :name="name" v-slot="{ field, errors }">
      <div class="relative flex h-10 w-full">
        <input
          :id="Math.random()"
          autocomplete="off"
          type="text"
          v-bind="field"
          :maxlength="maxLength"
          :placeholder="placeholder"
          @input="input"
          class="w-full h-11 px-4 rounded-md"
          :class="[
            classes,
            errors[0]
              ? 'border border-red-500'
              : hasBorder
              ? 'border border-gray-400'
              : '',
            color === 'yellow' ? 'bg-[#FFFFFF66]' : color,
            center ? 'text-center' : '',
          ]"
          @keypress="handleKeypress"
          @paste="handlePaste"
        />
        <span
          v-if="require"
          class="!absolute left-1 p-2 font-bold text-red-500"
        >
          *
        </span>
        <slot name="appendIcon"></slot>
      </div>
      <div
        v-if="!hide_error && errors.length"
        class="text-red-500 text-xs mt-1 ms-1 h-16 font-bold"
      >
        <p v-text="errors[0]" class="font-12" />
      </div>
    </VField>
  </div>
</template>

<script>
import { Field } from "vee-validate";
const { numberOnly, pasteNumber } = useInputHelpers();

export default {
  components: {
    VField: Field,
  },
  props: {
    classes: {
      type: String,
      required: false,
      default: "",
    },
    maxLength: {
      type: String || null,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    size: {
      type: String,
      required: false,
      default: "2xl",
      validate: () => "lg" || "2xl" || "full",
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: "",
    },
    require: {
      type: Boolean,
      required: false,
      default: false,
    },
    hide_error: {
      type: Boolean,
      required: false,
      default: false,
    },
    center: {
      type: Boolean,
      required: false,
      default: false,
    },
    heightAuto: {
      type: Boolean,
    },
    isNumber: Boolean,
  },
  setup(props, context) {
    const isPasswordVisible = ref(false);
    const input = (e) => {
      context.emit("updated", e.target.value);
    };
    const actionClicked = () => {
      context.emit("action");
    };
    const handleKeypress = (event) => {
      if (props.isNumber) {
        numberOnly(event);
      }
    };
    const handlePaste = (event) => {
      if (props.isNumber) {
        pasteNumber(event);
      }
    };

    return {
      input,
      actionClicked,
      isPasswordVisible,
      handleKeypress,
      handlePaste,
    };
  },
};
</script>
